// Kod w tym pliku zostanie załadowany na każdej podstronie Twojej strony

// import wixWindowFrontend from 'wix-window-frontend';
// const offset = 100;

$w.onReady(function () {
    //getScrollInfo();

    $w('#columnStrip2').onViewportLeave((event) => {
        $w('#sticky-header-menu').expand();
        $w('#scroll-top-button').expand();
        //$w('#textMarquee2').expand();
    })

    $w('#columnStrip2').onViewportEnter((event) => {
        $w('#sticky-header-menu').collapse();
        $w('#scroll-top-button').collapse();
        //$w('#textMarquee2').collapse();
    })

    let currentYear = new Date().getFullYear();
    $w('#text16').text = `Sami Swoi Radio © 2022 - ${currentYear}`; // Auto updates the copyright year in the footer

    // hideEmptyCart('shoppingCartIcon1');

});

import { cart } from 'wix-stores';

function hideEmptyCart(id) {
    cart.getCurrentCart().then(initialCart => switchIcon(initialCart));
    cart.onChange(changedCart => switchIcon(changedCart));

    function switchIcon(aCart) {
        let count = aCart.lineItems.length;
        let $icon = $w("#" + id);

        if (count) $icon.show();
        else $icon.hide();
    }
}

// Unfortunatelly, this makes the page load longer
/*
function getScrollInfo(params) {
    wixWindowFrontend.getBoundingRect()
        .then((windowSizeInfo) => {

            let scrollY = windowSizeInfo.scroll.y;

            if (scrollY > offset) {
                //$w('#columnStrip1').collapse();
                //$w('#columnStrip2').collapse();
                $w('#scroll-top-button').expand();
            } else {
                //$w('#columnStrip1').expand();
                //$w('#columnStrip2').expand();
                $w('#scroll-top-button').collapse();
            }

            setTimeout(() => {
                getScrollInfo();
            }, 1000);

        });
}
*/